import type { BaseSyntheticEvent, ComponentProps } from "react"

import filter from "lodash-es/filter"
import isEmpty from "lodash-es/isEmpty"

import type { TTFunction } from "$/i18n/i18n"

import { Link } from "@/3514/components/shared/link/link.component"
import {
    ETypographyColor,
    ETypographySize,
    ETypographyWeight
} from "@/3514/components/shared/typography/typography.types"
import { type TScreenBreakpoints } from "@/3514/hooks"
import type { IProductTypeModel } from "@/3514/types"
import { withPressHandler } from "@/3514/utils"
import { CARE_TEAM_EMAIL, ParticipantUrls } from "@/constants"

import { participantHeaderStyles as classes } from "./participant.header.styles"
import { EParticipantHeaderVariant } from "./participant.header.types"

function renderLinks({
    breakpoints,
    t,
    handleLogout,
    productType
}: {
    breakpoints: TScreenBreakpoints
    t: TTFunction
    handleLogout(e: BaseSyntheticEvent): void
    productType: IProductTypeModel
}): {
    [V in EParticipantHeaderVariant]: ComponentProps<typeof Link>[]
} {
    function _getSignOut({ isMobileOnboarding }: { isMobileOnboarding: boolean }): ComponentProps<typeof Link> {
        return {
            to: "#",
            styleless: true,
            textWeight: ETypographyWeight.Default,
            textColor: ETypographyColor.Black,
            textSize: isMobileOnboarding
                ? ETypographySize.Medium
                : breakpoints.xs || breakpoints.sm
                  ? ETypographySize.MediumPlus
                  : ETypographySize.Medium,
            children: t("common.signOut"),
            className: classes.desktop.listItem({ isMobileOnboarding }),
            onClick: withPressHandler(handleLogout),
            onKeyDown: withPressHandler(handleLogout)
        }
    }

    return {
        [EParticipantHeaderVariant.Default]: [
            {
                to: ParticipantUrls.PROFILE,
                styleless: true,
                textWeight: ETypographyWeight.Default,
                textColor: ETypographyColor.Black,
                textSize: breakpoints.xs || breakpoints.sm ? ETypographySize.MediumPlus : ETypographySize.Medium,
                children: t("participantSide.header.dropdown.profile.label"),
                className: classes.desktop.listItem({ isMobileOnboarding: false })
            },
            _getSignOut({ isMobileOnboarding: false })
        ],
        [EParticipantHeaderVariant.Onboarding]: filter<ComponentProps<typeof Link>>(
            [
                breakpoints.xs || breakpoints.sm
                    ? {
                          to: `mailto:${isEmpty(productType?.supportEmail) ? CARE_TEAM_EMAIL : productType.supportEmail}`,
                          styleless: true,
                          textWeight: ETypographyWeight.Default,
                          textColor: ETypographyColor.Black,
                          textSize: ETypographySize.Medium,
                          children: t("common.contactWiserCare"),
                          className: classes.desktop.listItem({ isMobileOnboarding: breakpoints.xs || breakpoints.sm })
                      }
                    : (false as never),
                _getSignOut({ isMobileOnboarding: breakpoints.xs || breakpoints.sm })
            ],
            Boolean
        )
    }
}

const headerConfig = { renderLinks }

export { headerConfig as participantHeaderConfig }
